import React from "react";
import { Box, SpaceBetween, Spinner } from "@amzn/awsui-components-console";

export interface LoadingIndicatorProps {
  /** Text rendered below the spinner. */
  label: string;
  /** Optional `data-testid` applied to the spinner element. */
  testId?: string;
}

/**
 * Centered Cloudscape spinner with a label underneath. Used as the
 * loading state for any in-page async operation that blocks the whole
 * content area (auth resolution, schema fetches, claim retrieval, etc.).
 *
 * Replaces several near-identical inline blocks that all rendered
 * `Box textAlign="center"` → `SpaceBetween` → `Spinner size="large"` →
 * `Box variant="p"`.
 */
function LoadingIndicator({ label, testId }: LoadingIndicatorProps): JSX.Element {
  return (
    <Box textAlign="center" padding={{ top: "xxxl" }}>
      <SpaceBetween size="m" direction="vertical" alignItems="center">
        <Spinner size="large" data-testid={testId} />
        <Box variant="p">{label}</Box>
      </SpaceBetween>
    </Box>
  );
}

export default LoadingIndicator;
